import { APP_VERSION, COUNTRY_CODE, EnvironmentType } from "./environment.type";

export const environment: EnvironmentType = {
  placement: "prod",
  production: true,
  route_hash: false,
  timezone: "America/Costa_Rica",
  code: COUNTRY_CODE.cr,
  currency: "CRC",
  grammar: "es",
  lang: "es",
  phone_length: 8,
  phone_prefix: "+506",
  max_tip: 25000,
  gateway: {
    base_url: "https://services.rappi.co.cr",
    csv_prefix: "/api/cargo-api-gateway/csv/portal/",
    location_gateway_prefix: "/api/cargo-api-gateway/core-maps/address/",
    gateway_prefix: "/api/cargo-api-gateway/portal/",
    settlement_prefix: "/api/cargo-api-gateway/portal/settlement/",
    cashless_prefix: "/api/ms/cargo-cashless/",
    maps_prefix: "/api/maps/v1/",
  },
  logoUrl: "https://cargo-core-api.s3.us-west-2.amazonaws.com/cr/cargo-logos/",
  trackingUrl: "cargo-tracking.rappi.co.cr/",
  aws_location: {
    api_key:
      "v1.public.eyJqdGkiOiI2NTZmMDlhYi04ZmY3LTQ3MGMtYjg2OC1kMzA2ZThlMmU5ZWUifVpaPJS2I9DzC49xXSueiT-McNdQi6oq5MVTNSP8WGTXV5iYyyxfp9IGnLU2fqNtrL67J1Ts22G20-VPGwGQnGKnq1pM606Ar2v8SpuHc48QCzUxrGS2HvuqLpPcUpKG0CXHM3vMSZyzUHGtMhSxS6JJrfL5-vlfCUgS7qlZSoHBo8CjaWtVrAZ_IQLp8cCCcAFN-0UjZ4NY41zZ6HUk8LLprMbD6niYe3gjN-_crt2Febl4mUsRFk7xJigYT2o8sbNnxMwhzLOflBp0Y4CLvA5koidX10VQBk-RSBE7EyEhvpYBlUw6Bw6X903XUC4aLXteM0UqajlllU0oQ47K42o.ZWU0ZWIzMTktMWRhNi00Mzg0LTllMzYtNzlmMDU3MjRmYTkx",
    region: "us-east-1",
    style: "Standard",
    color_scheme: "Light",
  },
  coordsCenter: { lat: 9.93333, lng: -84.08333 },
  currencySymbol: "₡",
  decimalPattern: /^[0-9]+([.]\d{0,0})?$/,
  decimalNumber: 0,
  country: {
    defaultLocale: "es-CR",
  },
  localeUrl: "https://cargo-core-api.s3.amazonaws.com/cr/cargo-logos/",
  auth0: {
    client_id: "hDcAOaY9heMYiAxYPvr5Ynt3ZeNybA43",
    client_secret: "OxnMGuC8OXHjYTgznaaKL2ItdOB4xdMj2jpTDbx6au00NQX47lBEdjgGXc6ia2m4",
    domain: "https://login.partners.rappi.com",
  },
  amplitude: {
    key: "032f00f0dfdad881e7391f28f35156f6",
  },
  i18n_version: APP_VERSION,
  kustomer_assistant_id: "664bbe3419e7a2316b52dc7a",
  recaptcha_site_key: "6Le98o0sAAAAAMT-KoXGJs6OW-aYF9sbNdbigJaR",
  amazon_connect: {
    snippet_id:
      "QVFJREFIaGRXUHpDQ0syTWozT3FtUTlKL1lZeW8zbzdUZEQ4Y1A3d0wzMWFuQ0RFM0FIUjdSZEdzTzJWYWV1Ynl4NjY4QmRCQUFBQWJqQnNCZ2txaGtpRzl3MEJCd2FnWHpCZEFnRUFNRmdHQ1NxR1NJYjNEUUVIQVRBZUJnbGdoa2dCWlFNRUFTNHdFUVFNWXRNZ0JBWUpaUHM2NkhSSkFnRVFnQ3NiNFdUQ0xxSVVDVXBTRldTQzlGU0xSanRhYTFXWm5kMG85RWRBNnB6TDV0bnFRRnQ4V1JlVVhDVGg6OmNGZ0IwVjVrUEhIWlIwNDAyN0ZTTmtMcUpseTYvVlI0enFiSkpCWTVDazQxV3BlTmlKN2V6VDUyblpDYmswMjRlS3NIQnlWN2ZiN3NTNmN3UHBFdjczbGVWRDhkMDlBb25sTGgxUVlGcStIcC9wSVlISDhSa2orSjdDQVIwaEJTZEdNQWJML2g1OXIrZ1RNUWhReXFOSTNDS3puS2RRUT0=",
    src: "https://connect-rappi-support-prod.my.connect.aws/connectwidget/static/amazon-connect-chat-interface-client.js",
    script_id: "37223493-6644-445d-bae1-7074a64d629c",
  },
};
